import { all, call, put } from 'redux-saga/effects';

import * as types from './conclusion.types';
import * as actions from './conclusion.actions';
import * as api from '../../api/request-config/conclusion.api';

import { apiRequest } from '../../api/api.saga-services';
import { select } from '../../../utils/selector.utils';
import { conclusionSelectors } from './conclusion.selectors';
import { ISession } from '../session/session.types';
import { IUser } from '../user/user.types';

export function* storeConclusion(conclusion: types.IConclusion) {
  yield put(actions.storeConclusion(conclusion));
}

export function* clearConclusion(conclusionId: types.IConclusion['id']) {
  yield put(actions.clearConclusion(conclusionId));
}

export function* clearAllConclusions() {
  const conclusionIds: types.IConclusion['id'][] = yield select(conclusionSelectors.selectResourceIds);
  yield put(actions.clearConclusion(conclusionIds));
}
export function* searchConclusions(sessionId: ISession['id']) {
  const conclusions: types.IConclusion[] = yield call(apiRequest, api.searchConclusionsApi(sessionId));

  yield all(conclusions.map((conclusion) => call(storeConclusion, conclusion)));
  return conclusions.map((conclusion) => conclusion.id);
}

export function* saveConclusion(
  sessionId: ISession['id'],
  userId: IUser['id'],
  conclusionData: types.IConclusionSaveData,
) {
  const conclusion = (yield call(
    apiRequest,
    api.saveConclusionApi(sessionId, userId, conclusionData),
  )) as types.IConclusion;

  if (!conclusion) {
    return;
  }

  yield call(storeConclusion, conclusion);
  return conclusion;
}

export function* deleteConclusion(sessionId: ISession['id'], userId: IUser['id']) {
  const conclusion = (yield call(apiRequest, api.deleteConclusionApi(sessionId, userId))) as types.IConclusion;

  if (!conclusion) {
    return;
  }

  yield call(clearConclusion, conclusion.id);
  return conclusion;
}
